import script from "./AfterSaveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterSaveDialog.vue?vue&type=script&setup=true&lang=js"

import "./AfterSaveDialog.vue?vue&type=style&index=0&id=6ef580c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef580c0"]])

export default __exports__